var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDirectUp = function SvgDirectUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A2AEBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.642 3.925-5.084 9.658c-1.208 2.292 1.234 4.784 3.55 3.625l2.7-1.35a2.665 2.665 0 0 1 2.384 0l2.7 1.35c2.316 1.159 4.75-1.333 3.55-3.625l-5.084-9.658c-1-1.9-3.716-1.9-4.716 0Z"
  })));
};
export default SvgDirectUp;